<div class="page-background">
  <div class="login-container">

    <div class="logo-container">
      <img src="assets/logo_beat.svg" alt="Logo Beat" class="logo">
    </div>

    <div class="login-header">
      <h2>{{'LOGIN.RECOVER' | translate }}</h2>
      <div class="separator">
        <span>{{ 'LOGIN.RECOVER_PASSWORD_INFO' | translate }}</span>
      </div>
    </div>

    <p>{{'LOGIN.YOUR_USERNAME_IS' | translate }}: {{ username }}</p>

    <form [formGroup]="passwordForm">
      <div class="password-container">
        <input [type]="hidePassword ? 'password' : 'text'"
               class="form-input"
               formControlName="newPassword"
               placeholder="{{ 'LOGIN.PASSWORD' | translate }}"
               [class.error]="passwordForm.get('newPassword')?.hasError('required') && passwordForm.get('newPassword')?.touched">

        <button type="button" class="password-toggle" (click)="hidePassword = !hidePassword">
          <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>

        <div class="error-message" *ngIf="passwordForm.get('password')?.hasError('required') && passwordForm.get('password')?.touched">
          {{ 'LOGIN.PASSWORD_REQUIRED' | translate }}
        </div>
      </div>

      <button type="submit" class="login-button" (click)="onSubmit()">{{ 'LOGIN.SEND_CHANGE' | translate }}</button>

    </form>

  </div>
</div>